import objectUtils from '../utils/object-utils'

export default class ProviderConnection {
  constructor (options = {}) {
    this.model = 'ProviderConnection'

    this.id = objectUtils.get(options, 'id', null)
    this.org_id = objectUtils.get(options, 'org_id', null)
    this.name = objectUtils.get(options, 'name', null)
    this.description = objectUtils.get(options, 'description', null)

    // Shipper
    this.shipper_id = objectUtils.get(options, 'shipper_id', null)
    this.shipper = objectUtils.get(options, 'shipper', {})

    // Provider info
    this.settings = objectUtils.get(options, 'settings', {})
    this.api_key = objectUtils.get(options, 'api_key', null)
    this.provider_alias = objectUtils.get(options, 'provider_alias', null)
    this.thirdparty_account_id = objectUtils.get(options, 'thirdparty_account_id', null)
    this.account = objectUtils.get(options, 'account', null)
    this.brands = objectUtils.get(options, 'brands', null)

    // Status
    this.status = objectUtils.get(options, 'status', null)

    // Vehicle lot created flag (on create results)
    this.vehicle_lot_created = options.vehicle_lot_created === true

    // Auditing
    this.created_by = objectUtils.get(options, 'created_by', null)
    this.created_at = objectUtils.get(options, 'created_at', null)
    this.updated_at = objectUtils.get(options, 'updated_at', null)
  }
}
